import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Link,
  Button,
} from '@mui/material';
import {
  Email as EmailIcon,
  Description as DescriptionIcon,
  BugReport as BugReportIcon,
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import SEO from '../components/SEO';
import { C } from '../theme';

const paperSx = { p: { xs: 3, md: 5 }, mb: 4, backgroundColor: C.surface, borderRadius: 4, border: `1px solid ${C.line}` };
const emailLinkSx = { color: '#F6CB4B', fontWeight: 600, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } };

const Contact: React.FC = () => {
  return (
    <>
      <SEO
        title="Kontaktirajte Nas"
        description="Kontaktirajte Nadji Investitora tim. Informacije o privatnosti, uslovima korišćenja i podrška."
        keywords="kontakt, podrška, privacy policy, uslovi korišćenja, nadji investitora"
        url="/contact"
      />
      <Box sx={{ pt: '110px', pb: 8, backgroundColor: C.bg, minHeight: '100vh' }}>
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography variant="h2" sx={{ fontWeight: 800, mb: 2, color: C.white }}>
              Kontaktirajte Nas
            </Typography>
            <Typography variant="h6" sx={{ color: C.muted, fontWeight: 400 }}>
              Vaš partner u povezivanju investitora, vlasnika zemljišta i poslovnih prilika
            </Typography>
          </Box>

          {/* About Us Section */}
          <Paper elevation={0} sx={paperSx}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color: C.white }}>
              O Nama
            </Typography>
            <Typography variant="body1" sx={{ color: C.muted, lineHeight: 1.8, mb: 2 }}>
              Nadji Investitora je platforma koja povezuje vlasnike zemljišta, poslovnih prostora i biznisa
              sa potencijalnim investitorima. Naša misija je da olakšamo proces pronalaženja investicionih
              prilika i omogućimo jednostavnu komunikaciju između zainteresovanih strana.
            </Typography>
            <Typography variant="body1" sx={{ color: C.muted, lineHeight: 1.8 }}>
              Bilo da tražite investiciju za vaš projekat ili investicionu priliku, naša platforma vam
              pruža alate i resurse potrebne za uspeh.
            </Typography>
          </Paper>

          {/* Contact Information */}
          <Paper elevation={0} sx={paperSx}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color: C.white }}>
              Kontakt Informacije
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <EmailIcon sx={{ mr: 2, color: C.gold }} />
              <Box>
                <Typography variant="body2" sx={{ color: C.muted, mb: 0.5 }}>
                  Opšta pitanja:
                </Typography>
                <Link href="mailto:info@nadjiinvestitora.com" sx={emailLinkSx}>
                  info@nadjiinvestitora.com
                </Link>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <BugReportIcon sx={{ mr: 2, color: C.gold }} />
              <Box>
                <Typography variant="body2" sx={{ color: C.muted, mb: 0.5 }}>
                  Tehnička podrška:
                </Typography>
                <Link href="mailto:info@nadjiinvestitora.com" sx={emailLinkSx}>
                  info@nadjiinvestitora.com
                </Link>
              </Box>
            </Box>
          </Paper>

          {/* Legal Documents */}
          <Paper elevation={0} sx={paperSx}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color: C.white }}>
              Pravni Dokumenti
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" startIcon={<DescriptionIcon />} component={RouterLink} to="/eula" sx={{ py: 1.5, justifyContent: 'flex-start' }}>
                  Uslovi Korišćenja (EULA)
                </Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" startIcon={<DescriptionIcon />} component={RouterLink} to="/privacy" sx={{ py: 1.5, justifyContent: 'flex-start' }}>
                  Privacy Policy
                </Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" startIcon={<DescriptionIcon />} href="/uploads/TC.pdf" target="_blank" sx={{ py: 1.5, justifyContent: 'flex-start' }}>
                  Terms &amp; Conditions
                </Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" startIcon={<DescriptionIcon />} href="/uploads/RC.pdf" target="_blank" sx={{ py: 1.5, justifyContent: 'flex-start' }}>
                  Refund &amp; Cancellation
                </Button>
              </Grid>
            </Grid>
          </Paper>

          {/* Report a Problem */}
          <Paper elevation={0} sx={{ ...paperSx, mb: 0, textAlign: 'center' }}>
            <BugReportIcon sx={{ fontSize: 48, color: C.gold, mb: 2 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: C.white }}>
              Prijavite Problem
            </Typography>
            <Typography variant="body2" sx={{ color: C.muted, mb: 3, lineHeight: 1.6 }}>
              Naišli ste na tehnički problem? Javite nam kako bismo mogli da ga rešimo.
            </Typography>
            <Button variant="contained" href="mailto:info@nadjiinvestitora.com?subject=Problem Report" sx={{ px: 4, py: 1.5 }}>
              Pošaljite Email
            </Button>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default Contact;
